export const isVisitPast = (
    visit: { eventDate: string; eventTime?: string | null },
    now: Date,
): boolean => {
    const start = new Date(`${visit.eventDate}T${visit.eventTime ?? "00:00"}`);
    if (Number.isNaN(start.getTime())) {
        return false;
    }
    return start.getTime() <= now.getTime();
};
